module.exports = __webpack_public_path__ + "static/img/index_bg.5fda08f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/index_bg.jpg
// module id = 5ZbD
// module chunks = 0